"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__or__wifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c3cd071c-2350-408c-97c9-030287165735",
    "data-name": "broadband-hi",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "broadband-hi"), /*#__PURE__*/React.createElement("g", {
    id: "f3790cac-2585-4e0e-b0b2-5db2991ecc92",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57392f06-f240-4fc9-9744-3663aaced590",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c69b0b8-d263-432b-8c0b-e3ac5b6bd646",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c2b764c-3fae-4f05-8b10-f4ac3ad0cf06",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1e215a72-b335-44c2-8423-049232a56a39",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c04750d6-69b1-4e11-80f0-82c237911fd0",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "976f759c-3ff7-448a-891d-836604870d34",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 118,
    r: 8,
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "88f527bf-1809-4d40-83c3-9475f51e02d5",
    "data-name": "<Pfad>",
    d: "M54.17,79.37a59.13,59.13,0,0,1,83.66,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "39be76c7-16f8-4cf1-a2c2-3a76d0498bfc",
    "data-name": "<Pfad>",
    d: "M66.28,90a42.25,42.25,0,0,1,59.77,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "63a0a696-2ce8-4d17-a736-42972150781d",
    "data-name": "<Pfad>",
    d: "M78.72,99.18a24.58,24.58,0,0,1,34.73,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))));
}

var _default = ic_broadband__or__wifi;
exports.default = _default;